export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  destinationId: string;
  destinationName: string;
  image: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'bali-complete-guide',
    title: '巴厘岛终极旅行攻略：10天玩转众神之岛',
    excerpt: '从乌布稻田到乌鲁瓦图悬崖，从库塔海滩到金塔马尼火山，这份10天深度游攻略带你领略巴厘岛最精华的风景与文化。',
    content: `<p>巴厘岛，这座被称为"众神之岛"的印度尼西亚明珠，每年吸引着数百万来自世界各地的游客。无论你是寻求浪漫蜜月的情侣，还是热爱探险的背包客，巴厘岛总能以它独特的方式打动你。</p>
<h2>最佳旅行时间</h2>
<p>巴厘岛一年分为旱季（4月-10月）和雨季（11月-3月）。旱季是最佳旅行时间，阳光明媚，湿度较低，非常适合户外活动。7月和8月是旅游旺季，游客最多，价格也最高。如果你想要更宁静的体验，建议选择4月-6月或9月-10月出行。</p>
<h2>10天行程安排</h2>
<h3>第1-3天：库塔与水明漾</h3>
<p>抵达巴厘岛后，先在库塔或水明漾安顿下来。库塔以冲浪和热闹的夜生活闻名，水明漾则有更多精致的餐厅和精品店。第一天可以在海滩放松，适应时差。第二天参加冲浪课程，感受印度洋的浪花。第三天探索水明漾的设计师店铺和海滩俱乐部。</p>
<h3>第4-6天：乌布文化之旅</h3>
<p>前往巴厘岛的文化心脏——乌布。这里是艺术家的聚集地，四周被翠绿的稻田和热带雨林环绕。参观乌布皇宫和传统市场，在德格拉朗梯田漫步，参加一堂传统的巴厘烹饪课。不可错过的还有圣猴森林和象窟遗址。</p>
<h3>第7-8天：北部山区探险</h3>
<p>向北前往金塔马尼火山地区，欣赏巴杜尔火山和巴杜尔湖的壮丽景色。清晨可以参加火山日出徒步，虽然辛苦但绝对值得。途经贝都古水神庙，这座水上寺庙是巴厘岛最上镜的景点之一。</p>
<h3>第9-10天：乌鲁瓦图与返程</h3>
<p>最后两天来到巴厘岛南端的乌鲁瓦图。悬崖上的乌鲁瓦图寺在日落时分格外壮观，别忘了观看传统的克差舞表演。在返程前，享受一顿悬崖餐厅的烛光晚餐，为这次巴厘岛之旅画上完美的句号。</p>
<h2>实用贴士</h2>
<p>交通方面，建议租一辆摩托车（需要国际驾照）或包车游览，这是最灵活的方式。饮食上，不要错过巴厘岛特色的烤乳猪和脏鸭餐。购物时记得砍价，这是当地市场的传统。</p>`,
    category: 'southeast-asia',
    categoryName: '东南亚',
    destinationId: 'bali',
    destinationName: '巴厘岛',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20Bali%20rice%20terraces%20in%20Ubud%20with%20palm%20trees%20and%20traditional%20Balinese%20temple%20in%20distance%2C%20golden%20morning%20light%2C%20lush%20green%20landscape%2C%20peaceful%20and%20serene%20atmosphere%2C%20professional%20travel%20photography%20with%20warm%20tones%2C%20clean%20balanced%20composition&width=1200&height=675&seq=article-bali-01&orientation=landscape',
    author: '林晓薇',
    date: '2026-07-15',
    readTime: '12分钟',
    tags: ['巴厘岛', '旅行攻略', '深度游', '海岛度假'],
    featured: true,
  },
  {
    id: 'tokyo-hidden-gems',
    title: '东京隐藏版景点大公开：在地人私藏的10个秘境',
    excerpt: '除了浅草寺和涩谷十字路口，东京还有哪些鲜为人知的绝美角落？跟随本地人的脚步，发现不一样的东京。',
    content: `<p>东京，这座全世界最令人着迷的都市之一，每年吸引超过1400万国际游客。但大多数人都挤在浅草寺、涩谷十字路口和筑地市场这些热门景点。其实，东京还有大量本地人私藏的秘境等待被发现。</p>
<h2>1. 等々力渓谷</h2>
<p>隐藏在世田谷区住宅街中的一片绿洲。这条约1公里长的溪谷两旁绿树成荫，设有散步道，潺潺流水声与鸟鸣相伴。这里还有一座小小的神社——等々力不動尊，是东京23区内唯一的溪谷，绝对是都市中的世外桃源。</p>
<h2>2. 清澄白河</h2>
<p>近年来成为东京的"咖啡圣地"，聚集了大量精品咖啡烘焙店。但除了咖啡，这里还有清澄庭园——一座典型的日式回游式庭园，人少安静，是逃离都市喧嚣的完美去处。</p>
<h2>3. 谷中银座</h2>
<p>这条充满昭和风情的商店街保留了东京旧时代的风貌。沿街有各种传统小吃、手工艺品店和猫咪主题咖啡馆。傍晚时分，夕阳洒在街道上的景象格外温馨，是拍摄怀旧风格照片的绝佳地点。</p>
<h2>4. 豪徳寺</h2>
<p>如果你喜欢招财猫，一定要来豪徳寺。传说这里是招财猫的发源地之一，寺院内摆放着成千上万只大大小小的招财猫雕像，场面既可爱又震撼。</p>
<h2>5. 神楽坂</h2>
<p>被称为"东京的小巴黎"，石板路两旁是传统的料亭、法式小酒馆和隐秘的酒吧。傍晚时分，偶尔还能看到艺伎匆匆走过的身影，古今东西的文化在这里奇妙地融合。</p>`,
    category: 'east-asia',
    categoryName: '东亚',
    destinationId: 'tokyo',
    destinationName: '东京',
    image: 'https://readdy.ai/api/search-image?query=Hidden%20alleyway%20in%20old%20Tokyo%20neighborhood%20with%20traditional%20wooden%20buildings%20and%20lanterns%2C%20warm%20evening%20light%2C%20nostalgic%20Showa%20era%20atmosphere%2C%20quiet%20and%20intimate%20scene%2C%20professional%20travel%20photography%2C%20clean%20composition&width=1200&height=675&seq=article-tokyo-02&orientation=landscape',
    author: '张明远',
    date: '2026-07-10',
    readTime: '10分钟',
    tags: ['东京', '秘境', '在地推荐', '深度旅行'],
    featured: true,
  },
  {
    id: 'maldives-honeymoon',
    title: '马尔代夫蜜月全攻略：选岛、预算与最佳体验',
    excerpt: '如何在马尔代夫上百个度假岛中选出最适合蜜月的那个？从一价全包到私岛探险，这篇攻略帮你做对每一个选择。',
    content: `<p>马尔代夫是蜜月旅行的终极梦想地。碧蓝的潟湖、纯白的沙滩和奢华的水上别墅，构成了一幅人间天堂的画卷。但面对上百个度假岛，如何选择最适合你们的那个？这篇攻略将帮你一步步规划完美的马尔代夫蜜月之旅。</p>
<h2>选岛指南</h2>
<p>马尔代夫实行"一岛一酒店"制度，选岛本质上就是选酒店。以下是几个关键考量因素：</p>
<h3>预算定位</h3>
<p>马尔代夫的度假岛大致分为三个档次：豪华顶级（如白马庄园、索尼娃贾尼）、中高端（如安纳塔拉、康斯坦茨）和经济型（如班多斯、芙花芬）。蜜月旅行建议至少选择中高端岛屿，预算约在每晚800-2000美元之间。</p>
<h3>上岛方式</h3>
<p>距离马累较近的岛屿可以乘坐快艇到达（约20-60分钟），较远的则需要水上飞机（约30-60分钟）。水上飞机本身是一次难忘的体验，可以从空中俯瞰散落在印度洋上的环礁美景，但费用较高（往返约400-600美元/人）。</p>
<h3>浮潜条件</h3>
<p>如果你是潜水爱好者，选择珊瑚环礁条件好的岛屿至关重要。南阿里环礁和芭环礁以丰富的海洋生物闻名，旱季（11月-4月）水下能见度最佳。</p>
<h2>最佳体验推荐</h2>
<p>除了在私人泳池里享受阳光，以下体验不容错过：在水下餐厅享用浪漫晚餐、乘坐多尼船出海看海豚、预约一次星空下的沙滩SPA、参加酒店安排的无人岛野餐。</p>`,
    category: 'south-asia',
    categoryName: '南亚',
    destinationId: 'maldives',
    destinationName: '马尔代夫',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20overwater%20villa%20with%20private%20pool%20in%20Maldives%20at%20sunset%2C%20candlelit%20dinner%20setup%20on%20wooden%20deck%2C%20turquoise%20lagoon%20water%2C%20pink%20and%20golden%20sky%2C%20dreamy%20honeymoon%20atmosphere%2C%20professional%20luxury%20travel%20photography&width=1200&height=675&seq=article-maldives-03&orientation=landscape',
    author: '陈思涵',
    date: '2026-07-05',
    readTime: '14分钟',
    tags: ['马尔代夫', '蜜月旅行', '选岛攻略', '奢华度假'],
    featured: true,
  },
  {
    id: 'seoul-food-guide',
    title: '首尔美食地图：从街头小吃到米其林，吃遍首尔不踩雷',
    excerpt: '炸鸡啤酒、韩牛烤肉、酱蟹拌饭...首尔是一座为美食而生的城市。跟着这份本地人推荐的美食清单，从广藏市场吃到江南高级餐厅。',
    content: `<p>如果说有一个城市专门为美食而生，那一定是首尔。从凌晨的醒酒汤到深夜的炸鸡啤酒，从市场里的辣炒年糕到米其林星级餐厅的韩定食，首尔的美食版图丰富到让人眼花缭乱。这份经过本地人和资深食客验证的美食地图，让你吃遍首尔不踩雷。</p>
<h2>传统市场篇</h2>
<h3>广藏市场</h3>
<p>首尔最具代表性的传统市场，也是Running Man等综艺节目的常客。必吃清单：绿豆煎饼、麻药紫菜包饭、生拌牛肉和活章鱼。市场中央的美食摊位从早上9点营业到晚上11点，建议避开午餐高峰时段前往。</p>
<h3>通仁市场</h3>
<p>这里的特色是用古钱币兑换便当，拿着铜钱在市场中挑选喜欢的菜品，组成属于你自己的韩式便当。体验感满分，拍照也很出片。</p>
<h2>烤肉天堂</h2>
<p>韩牛是来首尔必吃的顶级食材。推荐麻浦区的烤肉胡同，这里聚集了众多老字号烤肉店。韩牛大理石花纹细腻，入口即化，配上一碗冷面，是韩国人最爱的搭配。人均消费约3-5万韩元。</p>
<h2>咖啡与甜品</h2>
<p>首尔人对咖啡的热爱举世闻名，街头巷尾遍布着风格各异的咖啡馆。延南洞和圣水洞是近年最热门的咖啡街区，每家店的装潢都堪比艺术空间。必试的甜品包括雪冰、韩式刨冰和蜂蜜黄油面包。</p>`,
    category: 'east-asia',
    categoryName: '东亚',
    destinationId: 'seoul',
    destinationName: '首尔',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20Korean%20street%20food%20market%20in%20Seoul%20with%20various%20colorful%20traditional%20dishes%20displayed%2C%20steaming%20hot%20food%20stalls%2C%20warm%20evening%20atmosphere%2C%20busy%20and%20lively%20scene%2C%20professional%20food%20photography%20with%20rich%20colors&width=1200&height=675&seq=article-seoul-04&orientation=landscape',
    author: '王雨桐',
    date: '2026-06-28',
    readTime: '11分钟',
    tags: ['首尔', '美食', '街头小吃', '韩牛烤肉'],
    featured: false,
  },
  {
    id: 'kyoto-autumn',
    title: '京都红叶季完全指南：最佳赏枫时间和绝景寺院',
    excerpt: '每到深秋，京都便化身为一片红色的海洋。从永观堂到东福寺，从岚山到三千院，这篇指南带你捕捉京都最美的枫叶瞬间。',
    content: `<p>京都的红叶季是日本最具代表性的秋日风物诗。每年11月中旬至12月上旬，这座千年古都的寺院庭园、山林溪谷都被染上层层叠叠的红、橙、金色，美得令人屏息。</p>
<h2>红叶最佳观赏时间</h2>
<p>京都红叶的见顷（最佳观赏期）通常在11月中旬至12月上旬，但具体时间会受当年气温影响。一般来说，北部山区（如贵船、大原）的红叶较早，约11月上旬开始变色；市区寺院约11月中旬至下旬；岚山地区可持续到12月上旬。</p>
<h2>十大绝景赏枫寺院</h2>
<h3>东福寺</h3>
<p>京都红叶名所之首。从通天桥上俯瞰洗玉涧溪谷的红叶海洋，是京都最经典的秋日画面。建议清晨6点前到达排队，以避开人潮。红叶季特别开放至晚上8点。</p>
<h3>永观堂</h3>
<p>被称为"红叶的永观堂"，寺内约3000株枫树在秋季同时变色，与池泉回游式庭园交相辉映。夜枫点灯期间更是梦幻至极。</p>`,
    category: 'east-asia',
    categoryName: '东亚',
    destinationId: 'kyoto',
    destinationName: '京都',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Kyoto%20temple%20garden%20with%20vibrant%20red%20and%20orange%20autumn%20maple%20leaves%2C%20traditional%20Japanese%20wooden%20architecture%2C%20reflection%20in%20pond%2C%20peaceful%20zen%20atmosphere%2C%20soft%20afternoon%20light%2C%20professional%20travel%20photography%2C%20clean%20balanced%20composition&width=1200&height=675&seq=article-kyoto-05&orientation=landscape',
    author: '林晓薇',
    date: '2026-06-20',
    readTime: '13分钟',
    tags: ['京都', '红叶', '秋季旅行', '寺院'],
    featured: true,
  },
  {
    id: 'nepal-trekking',
    title: '尼泊尔徒步入门指南：从ABC到EBC，选择适合你的路线',
    excerpt: '喜马拉雅山脉拥有世界上最壮观的徒步路线。无论是入门级的ABC还是挑战极限的EBC，这份指南帮你找到最适合自己的那条路。',
    content: `<p>尼泊尔是徒步爱好者的终极天堂。这个世界上拥有最多8000米以上高峰的国家，为各种水平的徒步者提供了丰富的路线选择。从短途的茶园徒步到长达三周的高海拔环线，总有一条路线适合你。</p>
<h2>ABC（安纳普尔纳大本营）徒步</h2>
<p>ABC是尼泊尔最受欢迎的入门级徒步路线之一。全程约7-10天，最高海拔4130米，难度适中。沿途经过茂密的杜鹃花林、梯田村落和湍急的河流，最终到达安纳普尔纳大本营，被7000米以上的雪峰环绕。最佳季节是3月-5月（杜鹃花盛开）和10月-11月（天高气爽）。</p>
<h2>EBC（珠峰大本营）徒步</h2>
<p>这是世界上最经典的徒步路线之一，全程约14-16天，最高海拔5545米（卡拉帕塔）。难度中高，需要良好的体能和高原适应能力。沿途可以近距离欣赏珠穆朗玛峰、洛子峰和阿玛达布拉姆峰等世界最高峰。这里也是夏尔巴文化的核心区域，可以在南池市场体验独特的喜马拉雅山地文化。</p>`,
    category: 'south-asia',
    categoryName: '南亚',
    destinationId: 'nepal',
    destinationName: '尼泊尔',
    image: 'https://readdy.ai/api/search-image?query=Himalayan%20mountain%20trekking%20trail%20in%20Nepal%20with%20snow%20capped%20peaks%20in%20background%2C%20colorful%20prayer%20flags%20along%20path%2C%20adventure%20travel%20atmosphere%2C%20clear%20blue%20sky%2C%20dramatic%20landscape%2C%20professional%20outdoor%20photography&width=1200&height=675&seq=article-nepal-06&orientation=landscape',
    author: '张明远',
    date: '2026-06-15',
    readTime: '15分钟',
    tags: ['尼泊尔', '徒步', '喜马拉雅', '户外探险'],
    featured: false,
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter(a => a.category === categorySlug);
};

export const getArticleById = (id: string) => {
  return articles.find(a => a.id === id) || null;
};

export const getFeaturedArticles = () => {
  return articles.filter(a => a.featured).slice(0, 6);
};

export const getRelatedArticles = (currentArticleId: string, count: number = 3) => {
  const current = articles.find(a => a.id === currentArticleId);
  if (!current) return [];
  return articles
    .filter(a => a.id !== currentArticleId && a.category === current.category)
    .slice(0, count);
};